<template>
  <div>
    <div class="svincolati">
      <div
        v-show="showTitle"
        class="titolo navy--text text--lighten-2 font-hemi-head"
      >
        Svincolati
      </div>
      <div class="svincolati-options">
        <div>
          <v-row v-if="classic" align="center" justify="center" no-gutters>
            <v-col cols="auto">
              <select-ruoli-classic
                v-model="selectedRuoloClassic"
                :ruoliAllowed="ruoliAllowed"
              ></select-ruoli-classic>
              <!-- info -->
              <v-icon
                v-if="showInformazioni"
                color="text"
                small
                @click="showDialogInformazioni"
                >info</v-icon
              >
            </v-col>
          </v-row>
          <v-row v-else align="center" justify="center" no-gutters>
            <v-col cols="auto">
              <select-ruoli-mantra
                v-model="selectedRuoliMantra"
              ></select-ruoli-mantra>
            </v-col>
          </v-row>
          <v-row
            v-if="showButtonScartati"
            align="center"
            justify="center"
            no-gutters
          >
            <v-col cols="auto">
              <!-- v-if="_.size(scartati_ids) >0" -->
              <v-btn
                x-small
                outlined
                rounded
                class="mt-2 navy--text text--darken-3"
                @click="manageScartati"
                >Scartati</v-btn
              >
            </v-col>
          </v-row>
          <v-row align="center" justify="space-between" dense>
            <v-col v-if="showStats">
              <!-- <v-icon x-small left>fa-align-left</v-icon> -->
              <v-btn
                v-if="anniStats.length > 0"
                x-small
                rounded
                depressed
                class="navy darken-2 navy--text text--lighten-3"
                @click="rotateAnniStats"
              >
                <transition name="roll" mode="out-in"
                  ><b :key="annoStats">{{ annoStats }}</b></transition
                >
              </v-btn>
              <v-btn
                x-small
                rounded
                depressed
                class="btnHomeAway navy darken-2 navy--text text--lighten-3"
                @click="rotateHomeAway"
              >
                <transition name="roll" mode="out-in">
                  <div :key="homeAway">
                    <div v-if="homeAway == 'home'">
                      <v-icon x-small>fa-home</v-icon>
                    </div>
                    <div v-if="homeAway == 'away'">
                      <v-icon x-small>fa-plane</v-icon>
                    </div>
                    <div v-if="homeAway == 'homeAway'">
                      <v-icon x-small>fa-home</v-icon>
                      +
                      <v-icon x-small>fa-plane</v-icon>
                    </div>
                  </div></transition
                >
              </v-btn>
            </v-col>
            <v-col>
              <v-text-field
                class="calciatori-search"
                prepend-icon="search"
                label="Nome o squadra..."
                color="blue-grey lighten-2"
                v-model="nameFilter"
                :append-icon="nameFilter.length != 0 ? 'cancel' : ''"
                @click:append="resetFilter"
                hide-details
              >
              </v-text-field>
            </v-col>
          </v-row>
        </div>
      </div>

      <div class="svincolati-list">
        <div
          v-if="id_calciatori_svincolati.length == 0"
          class="text-center pa-10"
        >
          Nessuno svincolato in questo ruolo.<br />
          <div v-if="showButtonScartati && !includiScartati">
            PS: Clicca su "Scartati" per rivedere i calciatori che sono stati
            già scartati
          </div>
        </div>

        <div style="overflow: auto" v-else-if="ie">
          <!-- v-if="ie"-->
          <v-list two-line class="pa-0">
            <calciatore
              v-for="id in id_calciatori_svincolati"
              borderAsRuolo
              :showQuotazione="showQuotazione"
              :showMainStatus="showMainStatus"
              :showButtonsScartaRiabilita="showButtonsScartaRiabilita"
              :showStats="showStats"
              ruoloRight
              :class="{ textScuro, bgChiaro }"
              :key="id"
              :id="id"
              :selected="selected.bind(null, id)"
              :scartato="scartati_ids.indexOf(id) != -1"
            ></calciatore>
          </v-list>
        </div>
        <div v-else>
          <!-- :item-size="77" is the height of .vue-recycle-scroller__item-view -->
          <RecycleScroller
            class="recycle-scroller"
            :items="id_calciatori_svincolati"
            :item-size="showStats ? 91 : 65"
            ref="vscroll-list"
            :class="{ 'nice-scroll': !is_mobile }"
            v-slot="{ item: id_calciatore_svincolato }"
          >
            <calciatore
              borderAsRuolo
              :class="{ textScuro, bgChiaro }"
              :showQuotazione="showQuotazione"
              :showMainStatus="showMainStatus"
              :showButtonsScartaRiabilita="showButtonsScartaRiabilita"
              :showStats="showStats"
              ruoloRight
              :ripple="ripple"
              :id="id_calciatore_svincolato"
              :selected="selected.bind(null, id_calciatore_svincolato)"
              :scartato="scartati_ids.indexOf(id_calciatore_svincolato) != -1"
            ></calciatore>
          </RecycleScroller>
        </div>
      </div>
    </div>
    <v-dialog v-model="dialogInformazioni" max-width="350">
      <v-card>
        <v-card-title class="navy white--text">
          <v-icon class="white--text" left>info</v-icon>
          Ricorda
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="white--text"
            light
            icon
            @click="dismissDialogInformazioni"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <div class="white">
          <div
            class="pa-4"
            v-if="ruolo_da_chiamare == Constants.RUOLO_DA_CHIAMARE.QUALUNQUE"
          >
            PS: Se un ruolo non dovesse essere selezionabile è perchè quel ruolo
            è stato già completato da chi sta chiamando.
          </div>
          <div class="pa-4" v-else>
            PS: Se il ruolo non dovesse essere selezionabile è perchè quel ruolo
            è stato già completato da chi sta chiamando.
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import db from "../js/db";
import Constants from "../js/constants";
import Calciatore from "./common/Calciatore";
import SelectRuoliClassic from "./common/SelectRuoliClassic";
import SelectRuoliMantra from "./common/SelectRuoliMantra";
import Vuex from "vuex";
import mixins from "../js/mixins";
// https://github.com/Akryum/vue-virtual-scroller
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { RecycleScroller } from "vue-virtual-scroller";

export default {
  name: "asta-svincolati",
  components: {
    Calciatore,
    RecycleScroller,
    SelectRuoliClassic,
    SelectRuoliMantra,
  },
  mixins: [mixins],
  mounted() {
    console.log("--> AstaSvincolati ready.");
  },
  data() {
    return {
      selectedRuoloClassic: 0,
      selectedRuoliMantra: [],
      nameFilter: "",
      includiScartati: false,
      dialogInformazioni: false,
      // dialogAnniStats: false,
    };
  },
  props: {
    showInformazioni: {
      type: Boolean,
      default: false,
    },
    showButtonScartati: {
      type: Boolean,
      default: true,
    },
    showButtonsScartaRiabilita: {
      type: Boolean,
      default: false,
    },
    showStats: {
      type: Boolean,
      default: true,
    },
    showQuotazione: {
      type: Boolean,
      default: true,
    },
    showMainStatus: {
      type: Boolean,
      default: true,
    },
    dialogParent: {
      type: Boolean,
      default: null,
    },
    ripple: {
      type: Boolean,
    },
    selected: {
      type: Function,
      default: function () {},
    },
    ruoliAllowed: {
      type: Array,
      default: function () {
        return [
          Constants.RUOLO.P,
          Constants.RUOLO.D,
          Constants.RUOLO.C,
          Constants.RUOLO.A,
        ];
      },
    },
    squadre: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // acquisti: {
    //   type: Object,
    //   default: null,
    // },
    maxQuotazione: {
      type: Number,
      default: 0,
    },
    showTitle: {
      type: Boolean,
    },
    textScuro: {
      type: Boolean,
    },
    bgChiaro: {
      type: Boolean,
    },
  },
  watch: {
    // id_calciatori_svincolati: {
    //   handler(val) {
    //     console.log("id_calciatori_svincolati", val);
    //   },
    //   immediate: true,
    // },
    ruoliAllowed(val) {
      if (this.classic) {
        this.selectedRuoloClassic = val.length > 0 ? val[0] : -1;
      } else {
        this.selectedRuoloClassic = 0;
      }
    },
    mantra: {
      // lo uso per inizializzare i ruoli selezionati
      handler(val) {
        if (val) {
          // mantra
          this.selectedRuoloClassic = 0;
        } else {
          // classic
          this.selectedRuoloClassic = Constants.RUOLO.P;
          this.selectedRuoliMantra = []; // serve solo se un gg prevedo di cambiare tipo_ruoli in realtime
        }
      },
      immediate: true,
    },
    dialogParent(val) {
      // quando si chiude la dialog parent
      if (val == false) {
        this.resetFilter();
      }
    },
  },

  destroyed() {
    console.log("<-- AstaSvincolati destroyed.");
  },
  methods: {
    manageScartati() {
      db.emit("manageScartati");
    },
    rotateAnniStats() {
      let annoStatsNext;

      // Find the index of annoStats in the array
      const currentIndex = this.anniStats.indexOf(this.annoStats);

      // If annoStats is not found or it's the last element
      if (currentIndex === -1 || currentIndex === this.anniStats.length - 1) {
        // Return the first element of the array
        annoStatsNext = this.anniStats[0];
      } else {
        // Return the next element
        annoStatsNext = this.anniStats[currentIndex + 1];
      }

      this.$store
        .dispatch("setAnnoStats", annoStatsNext)
        .then(localStorage.setItem(Constants.LS_ANNO_STATS, annoStatsNext));
    },
    rotateHomeAway() {
      let homeAwayNext;

      // Find the index of annoStats in the array
      const currentIndex = Constants.HOME_AWAY_ARY.indexOf(this.homeAway);

      // If not found or it's the last element
      if (
        currentIndex === -1 ||
        currentIndex === Constants.HOME_AWAY_ARY.length - 1
      ) {
        // Return the first element of the array
        homeAwayNext = Constants.HOME_AWAY_ARY[0];
      } else {
        // Return the next element
        homeAwayNext = Constants.HOME_AWAY_ARY[currentIndex + 1];
      }

      this.$store
        .dispatch("setHomeAway", homeAwayNext)
        .then(localStorage.setItem(Constants.LS_HOME_AWAY, homeAwayNext));
    },
    // setAnnoStats(value) {
    //   this.$store.dispatch("setAnnoStats", value);
    //   localStorage.setItem(Constants.LS_ANNO_STATS, value);
    //   this.dismissDialogAnniStats();
    // },
    showDialogInformazioni() {
      this.dialogInformazioni = true;
    },
    dismissDialogInformazioni() {
      this.dialogInformazioni = false;
    },
    // showDialogAnniStats() {
    //   this.dialogAnniStats = true;
    // },
    // dismissDialogAnniStats() {
    //   this.dialogAnniStats = false;
    // },
    resetFilter() {
      this.nameFilter = "";
    },
    primoSvincolato() {
      return _.head(
        this.svincolati(
          this.selectedRuoloClassic,
          "",
          this.maxQuotazione,
          false,
          this.squadre,
          []
        )
      );
    },
  },
  computed: {
    ruolo_da_chiamare() {
      return this.asta_settings.ruolo_da_chiamare;
    },
    id_calciatori_svincolati() {
      return this.svincolati(
        this.selectedRuoloClassic,
        this.nameFilter,
        this.maxQuotazione,
        this.includiScartati,
        this.squadre,
        this.selectedRuoliMantra
      );
    },
    ...Vuex.mapGetters([
      "svincolati",
      "scartati_ids",
      "annoStats",
      "anniStats",
      "homeAway",
      "is_mobile",
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "../main.scss";
.svincolati {
  .svincolati-options {
    padding: 10px;
    height: 132px; // importante, vedi hack height in main.scss

    .calciatori-search {
      margin: 0;
      padding: 0;
    }
    .v-input__slot {
      justify-content: center;
    }
  }

  .btnHomeAway {
    min-width: 52px;
  }
  .roll-enter-active,
  .roll-leave-active {
    transition: all 0.1s;
  }

  .roll-enter {
    transform: translateY(50%);
    opacity: 0;
  }

  .roll-leave-to {
    transform: translateY(-50%);
    opacity: 0;
  }
  // .svincolati-list .recycle-scroller {
  //   // vale per la dialog
  //   height: 400px; // importante: deve essere specificato altrimenti reycler-scroller non funzionerà
  //   // e serve anche per far scrollare solo la lista invece che tutta la dialog
  // }
}
</style>
